import { CustomerTableQuery } from "../../common/models";
import { transformTableQueryForKy } from "../../helpers/tableHelpers";
import { privateGet } from "../clients/createPrivateClient";
import { TableResultCPCustomer } from "../models/unified";

export default {
  getCustomers: async (query: CustomerTableQuery) => {
    const result = await privateGet<TableResultCPCustomer>(
      `customerPortal/customer/v2`,
      {
        ...transformTableQueryForKy(query),
      },
    );

    return result;
  },
};
